import classNames from "classnames";
import React, { ReactNode } from "react";

import ACTrigger, { ACTriggerProps } from "ac-components/ACTrigger";

import "./ACPopover.less";

export interface Props extends Omit<ACTriggerProps, "popup"> {
  header?: ReactNode;
  footer?: ReactNode;
  content: ReactNode;
  children: ReactNode;
  style?: React.CSSProperties;
  className?: string;
}

export default function ACPopover({
  header,
  footer,
  children,
  content,
  style,
  className,
  placement = "bottomRight",
  trigger = "click",
  ...restTriggerProps
}: Props) {
  return (
    <ACTrigger
      placement={placement}
      trigger={trigger}
      popup={
        <div className={classNames("ac-popover", className)} style={style}>
          {header && <div className="ac-popover-header">{header}</div>}
          <div className="ac-popover-body">{content}</div>
          {footer && <div className="ac-popover-footer">{footer}</div>}
        </div>
      }
      {...restTriggerProps}
    >
      {children}
    </ACTrigger>
  );
}
